import React from 'react';
import { Button } from 'antd';
import { Icon } from '@common/components';
import { capitalize } from 'lodash';

export const FilterButton = ({
  keyName,
  value,
  clearFilter,
  labelName,
}: {
  keyName: string;
  value: string | number | boolean;
  clearFilter: (key: string, name?: string | number | boolean | null) => void;
  labelName: string;
}) => (
  <Button
    onClick={() => clearFilter(keyName, value)}
    key={`${keyName}-${value}`}
  >
    <Icon icon="xMark" kind="light" />
    {labelName || capitalize(value.toString().replace(/_/g, ' '))}
  </Button>
);
